__turbopack_context__.v({
  "error": "luck-module__QE4qHq__error",
  "footer": "luck-module__QE4qHq__footer",
  "fortuneCard": "luck-module__QE4qHq__fortuneCard",
  "fortuneText": "luck-module__QE4qHq__fortuneText",
  "header": "luck-module__QE4qHq__header",
  "loading": "luck-module__QE4qHq__loading",
  "main": "luck-module__QE4qHq__main",
  "page": "luck-module__QE4qHq__page",
  "pageContainer": "luck-module__QE4qHq__pageContainer",
  "phoneInput": "luck-module__QE4qHq__phoneInput",
  "registerButton": "luck-module__QE4qHq__registerButton",
  "registerContainer": "luck-module__QE4qHq__registerContainer",
  "retryButton": "luck-module__QE4qHq__retryButton",
});
